/*
 *   File : create-notification.js
 *   Author : https://evoqins.com
 *   Description :create notification modal
 *   Integrations : js-cookie
 *   Version : 1.0.0
*/

import { memo, useEffect, useState } from 'react'

// Custom components
import { PrimaryButton, TextButton } from '../Buttons';
import { Icon } from '../Icon';
import { CustomDatePicker, CustomFileUpload, CustomRadio, CustomTextInput, CustomTimePicker, TextArea } from '../FormElements';
import { toast } from 'react-toastify';
import { APIService, AWSService } from '../../Service';
import { format } from 'date-fns';
import { OverLay } from '../Others';
import { Modal } from 'bootstrap';

import styles from "../../Style/Component/notification.module.scss";
import moment from 'moment';


const TYPES = [
    {
        id: 1,
        label: "Send now"
    },
    {
        id: 2,
        label: "Schedule later"
    },
];

const REPEAT_TAB = [
    {
        id: 1,
        name: "Weekly"
    },
    {
        id: 2,
        name: "Monthly"
    },
    {
        id: 3,
        name: "Yearly"
    },
];


const CreateNotificationModal = (props) => {


    const [title, setTitle] = useState("");
    const [titleError, setTitleError] = useState("");
    const [content, setContent] = useState("");
    const [contentError, setContentError] = useState("");
    const [image, setImage] = useState(null);
    const [imageError, setImageError] = useState("");
    const [imageLoader, setImageLoader] = useState(false);

    const [errorUpdate, setErrorUpdate] = useState(false);

    const [scheduleTitle, setScheduleTitle] = useState("");
    const [scheduledImage, setScheduledImage] = useState(null);
    const [repeatTab, setRepeatTab] = useState(1);

    const [selectedDay, setSelectedDay] = useState(null);
    const [selectedDayError, setSelectedDayError] = useState("");
    const [dateToggle, setDateToggle] = useState(false);

    const [showTimePicker, setShowTimePicker] = useState(false);
    const [selectedTime, setSelectedTime] = useState(null);
    const [timeError, setTimeError] = useState("");
    const [repeatToggle, setRepeatToggle] = useState(false);
    const [sendCreateLoader, setSendCreateLoader] = useState(false);
    const [notificationId, setNotificationId] = useState(null);

    const [selectedType, setSelectedType] = useState(1);

    const [preview, setPreview] = useState(false);

    useEffect(() => {

        if (Object.keys(props.editData).length !== 0) {
            setSelectedType(2);
            setSelectedDay(props.editData.date);

            const updated_time = moment(props.editData.time, 'h:mm a');
            setSelectedTime(updated_time);

            setTitle(props.editData.title);
            setContent(props.editData.description);
            setImage(props.editData.image_url);
            setNotificationId(props.editData.notification_id);

            if (props.editData.repetition_type !== null) {
                setRepeatToggle(true);
                setRepeatTab(props.editData.repetition_type);
            }
        }
    }, [props.editData]);

    useEffect(() => {
        if (dateToggle === true) {
            const date_modal = new Modal(document.getElementById('date-modal'));
            date_modal.show();
        }
    }, [dateToggle]);

    useEffect(() => {
        setSelectedDayError("");
    }, [selectedDay, selectedType]);

    useEffect(() => {
        setTimeError("");
    }, [selectedTime, selectedType]);

    useEffect(() => {
        setTitleError("");
    }, [title]);

    useEffect(() => {
        setContentError("");
    }, [content]);

    useEffect(() => {
        setImageError("");
    }, [image]);

    // handle close Modal 
    const _handleCloseModal = () => {
        if (preview) {
            setPreview(false);
        } else {
            var button = document.getElementById("create-notification-modal-close");
            button.click();
            props.handleClose();
        }
    };

    // handle upload image
    const _uploadedImage = (url) => {
        setImageLoader(true);
        _getPresignedUrl(url, 1);
    };

    // handle Image change 
    const _handleChangeImage = () => {
        setImage(null);
    };

    // date toggle show an hide
    const _handleDateToggle = () => {
        setDateToggle(!dateToggle);
    };

    // handle select start date
    const _handleSelectedDate = (day) => {
        setSelectedDay(day);
        setDateToggle(false);
        _handleCloseStartDateModal();
    };

    // handle close start date modal 
    const _handleCloseStartDateModal = () => {
        var button = document.getElementById("date-modal-close");
        button.click();
        setDateToggle(false);
    };

    // handle show time picker 
    const _handleShowTimePicker = () => {
        setShowTimePicker(!showTimePicker)
    }

    // handle time change 
    const _handleTimeChange = (value) => {
        setSelectedTime(value);
    };

    // handle tab change 
    const _handleRepeatTabChange = (id) => {
        setRepeatTab(id);
    };

    // handle repeat toggle 
    const _handleRepeatToggle = () => {
        setRepeatToggle(!repeatToggle);
    };

    // handle success
    const _handlePreview = () => {
        let is_valid = true;

        if (title.trim().length === 0) {
            setTitleError("Required notification title");
            is_valid = false;
        }
        if (content.trim().length === 0) {
            setContentError("Push notification message is required");
            is_valid = false;
        }
        if (image === null) {
            setImageError("Image is required");
            is_valid = false;
        }

        setErrorUpdate(prev => !prev);


        if (selectedType === 2) {
            if (selectedDay === null) {
                setSelectedDayError("Date is required");
                is_valid = false;
            }

            if (selectedTime === null) {
                setTimeError("Time is required");
                is_valid = false;
            }

        }

        if (is_valid === true) {
            setPreview(true);
        }


    };

    const _handleConfirm = () => {
        setSendCreateLoader(true);

        if (selectedType === 1) {
            _sendPushNotification();
        } else {
            if (notificationId == null) {
                _schedulePushNotification();
            } else {
                _updateSchedulePushNotification();
            }
        }
    };

    // get presigned url
    async function _getPresignedUrl(file, type) {
        let is_post = true;
        let url = 'general/file-upload';
        let data = {
            "file": file.name,
            "is_public": true
        };
        try {
            let response = await APIService(is_post, url, data);
            if (response.status_code == 200) {
                let aws_fields = response.data.upload_info.fields;
                let aws_url = response.data.upload_info.url;

                try {
                    let aws_response = await AWSService(aws_fields, file, aws_url);
                    if (aws_response.status == 'ok') {
                        if (type === 1) {
                            setImage(response.data.view_info);
                        } else {
                            setScheduledImage(response.data.view_info);
                        }
                    } else {
                        toast.dismiss();
                        toast.error(aws_response.message, {
                            type: "error",
                            className: "e-toast",
                        });
                    }
                } catch (err) {
                    console.log("error")
                }
            } else {
                toast.dismiss();
                toast.error(response.message, {
                    type: "error",
                    className: "e-toast",
                });
            }
        } catch (err) {
        }
        setImageLoader(false);
    };

    // API - Send push notification
    const _sendPushNotification = () => {
        let is_post = true;
        let url = 'CA/notifications/send';
        let data = {
            "title": title,
            "description": content,
            "image_url": image
        };

        APIService(is_post, url, data).then((response) => {
            if (response.status_code === 200) {

                toast.dismiss();
                toast.success("Push notification send successfully", {
                    type: "success",
                    className: "e-toast",
                });

                setTitle("");
                setContent("");
                setImage(null);

                var button = document.getElementById("create-notification-modal-close");
                button.click();
                props.handleSuccess();

            } else {
                toast.dismiss();
                toast.error(response.message, {
                    type: "error",
                    className: "e-toast",
                })
            }
            setSendCreateLoader(false);
        });
    };

    // API - Schedule push notification
    const _schedulePushNotification = () => {
        let is_post = true;
        let url = 'CA/notifications/schedule-notification';
        let data = {
            "title": title,
            "description": content,
            "image_url": image,
            "date": format(selectedDay, 'yyyy-MM-dd'),
            "time": selectedTime.format('HH:mm:ss'),
            "repetition": repeatToggle === false ? null : repeatTab
        };

        APIService(is_post, url, data).then((response) => {
            if (response.status_code === 200) {

                toast.dismiss();
                toast.success("Push notification scheduled successfully", {
                    type: "success",
                    className: "e-toast",
                });

                setSelectedDay(null);
                setSelectedTime(null);
                setRepeatToggle(false);

                var button = document.getElementById("create-notification-modal-close");
                button.click();
                props.handleSuccess();
            } else {
                toast.dismiss();
                toast.error(response.message, {
                    type: "error",
                    className: "e-toast",
                })
            }
            setSendCreateLoader(false);
        });
    };

    // API - Update schedule push notification
    const _updateSchedulePushNotification = () => {
        let is_post = true;
        let url = 'CA/notifications/update-scheduled-notification';
        let data = {
            "notification_id": notificationId,
            "title": title,
            "description": content,
            "image_url": image,
            "date": format(selectedDay, 'yyyy-MM-dd'),
            "time": selectedTime.format('HH:mm:ss'),
            "repetition_type": repeatToggle === false ? null : repeatTab
        };

        APIService(is_post, url, data).then((response) => {
            if (response.status_code === 200) {

                toast.dismiss();
                toast.success("Push notification updated successfully", {
                    type: "success",
                    className: "e-toast",
                });

                setSelectedDay(null);
                setSelectedTime(null);
                setRepeatToggle(false);

                var button = document.getElementById("create-notification-modal-close");
                button.click();
                props.handleSuccess();
            } else {
                toast.dismiss();
                toast.error(response.message, {
                    type: "error",
                    className: "e-toast",
                })
            }
            setSendCreateLoader(false);
        });
    };

    return (
        <>
            <div className="modal fade" id="create-notification-modal" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="confirmDeleteModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered modal-md modal-dialog-scrollable">
                    <div className="modal-content e-border-radius-12 w- mx-auto py-4 px-3 ">
                        <img src={require("../../Assets/Image/CountryAdmin/close-icon.svg").default}
                            draggable={false}
                            className='d-none'
                            id='create-notification-modal-close'
                            alt='close'
                            data-bs-dismiss="modal" />

                        <div className="modal-header px-2 pt-0 pb-2 border-0 flex-column gap-2 align-items-start">
                            <div className='d-flex align-items-enter justify-content-between w-100'>
                                <h4 className='mb-0 e-primary-font-playfair e-text-raisin-black e-font-18 e-font-weight-500 line-height-28px'>
                                    {preview === false ? `${notificationId === null ? "Create notification" : "Edit notification"} ` : "Preview notification"}
                                </h4>
                                <Icon icon="close-icon"
                                    className='cursor-pointer'
                                    size="24px"
                                    onPress={_handleCloseModal} />

                            </div>
                            {/* <p className='mb-0 e-text-davys-grey e-alt-font-noto-sans e-font-14 e-font-weight-400 line-height-20px'>
                                Lorem ipsum snt amet.
                            </p> */}
                        </div>

                        <div className="modal-body px-2 pt-2 pb-4 ">
                            {preview === false ?
                                <>
                                    <CustomTextInput label="Title"
                                        placeholder="Notification title"
                                        type="text"
                                        require
                                        value={title}
                                        error={titleError}
                                        className="w-100"
                                        labelStyle="e-font-weight-500 e-text-raisin-black"
                                        handleChange={(e) => setTitle(e)} />

                                    {/* content */}
                                    <TextArea label="Content"
                                        placeholder="Enter your text..."
                                        type="text"
                                        rows="3"
                                        require
                                        value={content}
                                        error={contentError}
                                        className=" px-3 padding-12px-tb w-100"
                                        handleChange={(e) => setContent(e)} />

                                    {/* file upload */}
                                    <div >
                                        <CustomFileUpload label="Upload image"
                                            placeholder="Drop your image here"
                                            require
                                            file={image}
                                            fileType={["JPG", "PNG", "JPEG"]}
                                            resolution="328px * 150px"
                                            requiredWidth={328}
                                            requiredHeight={150}
                                            errorUpdate={errorUpdate}
                                            error={imageError}
                                            loader={imageLoader}
                                            handleChange={_uploadedImage} />

                                        {/* change image button */}
                                        {image !== null &&
                                            <div className='mb-2 margin-neg-20px-top'>
                                                <TextButton name="Change image"
                                                    onPress={_handleChangeImage} />
                                            </div>
                                        }
                                    </div>


                                    <CustomRadio label="Send Timing"
                                        required={true}
                                        data={TYPES}
                                        gap=" gap-3"
                                        selected={selectedType}
                                        onClick={(id) => setSelectedType(id)} />


                                    {selectedType === 2 &&
                                        <>
                                            <div className='pt-3 row g-3 w-100 flex-fill'>
                                                <div className='col-6'>
                                                    <p className='mb-0 e-text-raisin-black e-alt-font-noto-sans e-font-14 e-font-weight-400 line-height-20px'>
                                                        Pick start date<span className='e-text-lust'>*</span>
                                                    </p>
                                                    {/* Pick date  */}
                                                    <div className='pt-2'>
                                                        <div className='position-relative h-60px'>
                                                            <div className={`${dateToggle ? 'e-border-1px-indigo' : 'e-border-1px-platinum-light'} d-flex justify-content-between e-border-radius-6 padding-14px-tb px-3 cursor-pointer`}
                                                                onClick={_handleDateToggle}>

                                                                {selectedDay !== null ?
                                                                    <p className='mb-0 e-text-raisin-black e-alt-font-noto-sans e-font-14 e-font-weight-400 line-height-16px'>
                                                                        {format(selectedDay, 'PP')}
                                                                    </p>
                                                                    :
                                                                    <p className='mb-0 e-text-davys-grey e-alt-font-noto-sans e-font-14 e-font-weight-400 line-height-16px'>
                                                                        Choose date
                                                                    </p>
                                                                }



                                                                {/* clear icon */}
                                                                {selectedDay !== null ?
                                                                    <div onClick={(e) => e.stopPropagation()}>
                                                                        <Icon icon="close-icon"
                                                                            className='position-absolute top-14px right-14px cursor-pointer'
                                                                            size={18}
                                                                            onPress={() => setSelectedDay(null)} />
                                                                    </div>
                                                                    :
                                                                    <img src={require("../../Assets/Image/CountryAdmin/Notification/calendar-icon.svg").default}
                                                                        draggable={false}
                                                                        alt='calender-icon' />
                                                                }
                                                            </div>

                                                            {/* error message */}
                                                            <p className='mb-0 e-error-message e-alt-font-noto-sans e-font-12 line-height-12px padding-2-top'>
                                                                {selectedDayError}
                                                            </p>


                                                        </div>
                                                    </div>
                                                </div>

                                                <div className='col-6 pe-0'>
                                                    <CustomTimePicker label="Set time"
                                                        showSecond={false}
                                                        placeholder='Choose a time'
                                                        value={selectedTime}
                                                        open={showTimePicker}
                                                        error={timeError}
                                                        handleClose={_handleShowTimePicker}
                                                        handleOpen={_handleShowTimePicker}
                                                        handleChange={_handleTimeChange} />
                                                </div>


                                            </div>

                                            {/* Repeat notification */}
                                            <div className='e-display-flex justify-content-space-between pt-1'>
                                                <p className='mb-0 e-text-raisin-black e-alt-font-noto-sans e-font-16 e-font-weight-400 line-height-22px'>
                                                    Repeat this notification
                                                </p>
                                                <label className={`${styles.e_repeatnotification} `} >
                                                    <input type="checkbox"
                                                        checked={repeatToggle}
                                                        onChange={_handleRepeatToggle} />
                                                    <span className={`${styles.e_slider}`}></span>
                                                </label>
                                            </div>
                                            <div >
                                                {/* Repeat tab  */}
                                                {repeatToggle &&
                                                    <div className='d-flex gap-0-10 pt-3'>
                                                        {REPEAT_TAB.map((data, key) => (
                                                            <div key={key} className={`${repeatTab === data.id ? 'e-border-1px-lust cursor-default' : 'e-border-1px-platinum-light cursor-pointer'} e-text-raisin-black e-border-radius-8 r`}
                                                                onClick={() => _handleRepeatTabChange(data.id)} >
                                                                <p className='mb-0 px-4 py-2 e-alt-font-noto-sans e-font-16 e-font-weight-500 line-height-22px'>
                                                                    {data.name}
                                                                </p>
                                                            </div>
                                                        ))}
                                                    </div>
                                                }
                                            </div>
                                        </>
                                    }
                                </>
                                :
                                <>
                                    <CustomTextInput label="Title"
                                        placeholder="Notification title"
                                        type="text"
                                        value={title}
                                        require
                                        readOnly={true}
                                        error={titleError}
                                        className="w-100"
                                        labelStyle="e-font-weight-500 e-text-raisin-black"
                                        handleChange={(e) => setTitle(e)} />
                                    <div className='pt-2'>
                                        <TextArea label="Content"
                                            placeholder="Enter your text..."
                                            type="text"
                                            require
                                            rows="3"
                                            readOnly={true}
                                            value={content}
                                            error={contentError}
                                            className=" px-3 padding-12px-tb w-100"
                                            handleChange={(e) => setContent(e)} />
                                    </div>
                                    <div className='mt-1'>
                                        <img src={image}
                                            draggable={false}
                                            className='w-100 e-border-radius-16  object-fit-cover'
                                            height={120}
                                            alt='notification' />
                                    </div>
                                </>
                            }
                        </div>

                        <div className='modal-footer border-0 pt-2 pb-0 px-2'>
                            {preview === false ?
                                <PrimaryButton name={"Preview"}
                                    className="w-100"
                                    onPress={_handlePreview} />
                                :
                                <PrimaryButton name={selectedType === 1 ? "Confirm & send" : `${notificationId === null ? "Confirm & schedule" : "Update & schedule"} `}
                                    className="w-100"
                                    status={sendCreateLoader}
                                    onPress={_handleConfirm} />
                            }
                        </div>
                    </div>
                </div>
            </div>
            {dateToggle &&
                <div className="modal fade" id="date-modal" data-bs-backdrop="false" tabIndex="-1" aria-labelledby="dateModalLabel" aria-hidden="true"
                    onClick={_handleCloseStartDateModal}>
                    <div className="modal-dialog modal-dialog-centered e-border-radius-24 ">
                        <button id='date-modal-close'
                            className='d-none '
                            data-bs-dismiss="modal" />
                        <div className="modal-content w-358px  mx-auto border-0 bg-transparent e-date-modal-box-shadow ">
                            <CustomDatePicker type="modal"
                                minDate={new Date()}
                                selected={selectedDay}
                                onSelect={_handleSelectedDate} />
                        </div>
                    </div>
                </div>
            }
        </>

    )
}


export default memo(CreateNotificationModal);